export const timeStripHours = 24 * 7;

//USER ROLE VALUE
export const USER_ROLE_VALUE_ADMIN = "Admin";

//API RESPONSE TYPE
export const API_RESPONSE_TYPE_SUCCESS = 'Success';
export const API_RESPONSE_TYPE_ERROR = 'Error';
export const API_RESPONSE_TYPE_WARNING = 'Warning';

//TOASTER RESPONSE TYPE
export const TOASTER_RESPONSE_TYPE_SUCCESS = 'Success';
export const TOASTER_RESPONSE_TYPE_ERROR = 'Error';
export const TOASTER_RESPONSE_TYPE_INFO = 'Info';
export const TOASTER_TYPE_FAILURE = 'Failure';
export const TOASTER_TYPE_WARNING = 'Warning';

//STATUS TYPE
export const STATUS_TYPE_SUCCESS = 'Success';
export const STATUS_TYPE_ERROR = 'Error';
export const STATUS_TYPE_INFO = 'Info';
export const STATUS_TYPE_FAILURE = 'Failure';
export const STATUS_TYPE_WARNING = 'Warning';
export const STATUS_TYPE_COMPLETED = 'Completed';
export const STATUS_TYPE_INCOMPLETE = "InComplete";

//STATUS  
export const IS_ACTIVE_YES = "Y";
export const IS_ACTIVE_NO = "N";
export const IS_ACTIVE_UPLOAD = "U";
export const STATUS_IS_ACTIVE = "Active";
export const STATUS_IN_ACTIVE = "Inactive";
export const STATUS_DE_ACTIVE = "Deactive";

//OPTION 
export const OPTION_SELECT = "Select";
export const OPTION_ALL = "All";
export const OPTION_SELECTId = 0;

//ACTION
export const ACTION_LOGIN = "Login";
export const ACTION_LOGOUT = "Logout";